import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "home",
  "use": "home-usage",
  "viewBox": "0 0 20 19.78",
  "content": "<symbol viewBox=\"0 0 20 19.78\" id=\"home\"><title>home</title><path id=\"home__路径_\" data-name=\"&lt;路径&gt;\" d=\"M11.77,13.36a.58.58,0,0,1,.58.58c0,.62,0,1.36,0,1.86h0v2.92a1.16,1.16,0,0,0,1.16,1.16h2.59a1.76,1.76,0,0,0,2-1.93c0-2.2,0-6.23,0-8.65l.57.53a.76.76,0,0,0,.83.24A.77.77,0,0,0,20,9.44a.94.94,0,0,0-.43-.83L10.82.54C10.2,0,9.87,0,9.24.54l-4.35,4L.44,8.62A1,1,0,0,0,0,9.35.73.73,0,0,0,1.07,10a1.89,1.89,0,0,0,.41-.3L2,9.25c0,2.4,0,6.45,0,8.65a1.77,1.77,0,0,0,2,2H6.54a1.16,1.16,0,0,0,1.16-1.16V17.9s0,0,0,0c0-.19,0-.38,0-.57V15.8c0-.5,0-1.24,0-1.86a.58.58,0,0,1,.58-.58Z\" transform=\"translate(0 -0.11)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/home.svg
// module id = J8GQ
// module chunks = 264